import React, { useState } from "react";

function CommentItem({ comment }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <li onClick={toggleExpanded}>
      {/* Shortened comment display */}
      <span>Par le: </span> {comment.title}
      {/* Expandable full comment (conditionally rendered) */}
      {expanded && <div className="full-comment">{comment.comment}</div>}
    </li>
  );
}

function CommentsList({ comments }) {
  return (
    <ul>
      {comments.map((comment, index) => (
        <CommentItem key={index} comment={comment} />
      ))}
    </ul>
  );
}

export default CommentsList;
